/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
import "./Stamreeks.scss";
import { ParentComponent } from "./Genealogy/GenealogyComponents";
import React from "react";
import { GenealogySource, Parent } from "./Genealogy/types";
import { ReactElement } from "react";

export class Stamreeks extends React.Component<{ content: ReactElement; sources: GenealogySource[]; parents: Parent[] }, {}> {
  sources: GenealogySource[] = [];
  parents: Parent[];
  content: ReactElement;

  constructor(props: { content: ReactElement; sources: GenealogySource[]; parents: Parent[] }) {
    super(props);
    this.content = props.content;
    this.sources = props.sources;
    this.parents = props.parents;
  }

  renderSources = (sources: GenealogySource[]) => {
    return (
      <div className="table-container">
        <table className="oddEvenStyle">
          <thead>
            <tr>
              <th>Nr</th>
              <th>Kenmerk</th>
              <th>Jaar</th>
              <th>Bron</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody>{sources.map((source: GenealogySource, index: number) => this.renderSource(source, index))}</tbody>
        </table>
      </div>
    );
  };

  renderSource = (source: GenealogySource, index: number) => {
    return (
      <tr key={index}>
        <td>{source.index}</td>
        <td className="left">
          <a id={"footnote-" + source.index} href={source.url}>
            {source.filename}
          </a>
        </td>
        <td>{source.year}</td>
        <td>{source.name}</td>
        <td>{source.type}</td>
      </tr>
    );
  };

  render() {
    return (
      <div>
        <div className="box light">
          <div className="row">
            {this.content}

            <ol className="parent">{this.parents && this.parents.map((parent: Parent, index: number) => <ParentComponent parent={parent} index={index} key={index} />)}</ol>
          </div>
        </div>
        <div className="box main">
          <div className="row">
            <h3>Legenda</h3>
            <div className="table-container">
              <table>
                <tbody>
                  <tr>
                    <td>*</td>
                    <td className="left">geboren</td>
                    <td>✝︎</td>
                    <td className="left">overleden</td>
                  </tr>
                  <tr>
                    <td>〰</td>
                    <td className="left">gedoopt</td>
                    <td>[]</td>
                    <td className="left">begraven</td>
                  </tr>
                  <tr>
                    <td>⚭</td>
                    <td className="left">gehuwd</td>
                    <td>n.n.</td>
                    <td className="left">Nomen Nescio; zonder naam</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div className="box light">
          <div className="row">
            <h3>Bronnen</h3>

            {this.renderSources(this.sources)}
          </div>
        </div>
      </div>
    );
  }
}
